const KEY = "dl_interests";

export function recordInterest(tag) {
  if (!tag) return;
  try {
    const arr = JSON.parse(localStorage.getItem(KEY) || "[]");
    arr.unshift(String(tag));
    localStorage.setItem(KEY, JSON.stringify(arr.slice(0, 12)));
  } catch { /* ignore */ }
}

export function getInterests() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

export function getTopInterest() {
  const arr = getInterests();
  return arr[0] || null;
}
